import { createSelector } from 'reselect';
import { resourcePath } from '@gameday/utils/resource-path';
import { getSafeLanguagePath } from '@gameday/utils/languageHelpers';
const getGamePk = (state) => state?.gumbo?.gamePk || '';
const getDeviceInteraction = (state) => state?.config?.deviceInteraction;
const getLanguage = (state) => state?.config?.language;
const getAppPath = (state) => state?.config?.appPath ?? '';
const getRecap = (state) => {
    const {
        recap: {
            headline,
            blurb,
            linkId,
            templateUrl,
            isDataLoaded,
            error
        } = {}
    } = state;

    return {
        headline,
        blurb,
        linkId,
        templateUrl,
        isDataLoaded,
        error
    };
};

export const getRecapState = createSelector(
    [getRecap, getDeviceInteraction, getLanguage, getGamePk, getAppPath],
    (recap, deviceInteraction, language, gamePk, appPath) => {
        const recapLink = resourcePath.get('recapLink', {
            game_pk: gamePk,
            cid: recap?.linkId,
            appPath,
            languagePath: getSafeLanguagePath(language)
        });

        return {
            ...recap,
            deviceInteraction,
            language,
            gamePk,
            recapLink,
            contentId: recap?.linkId
        };
    }
);
